var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddTeamManually(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 0.833252C11.6159 0.833252 10.768 1.18444 10.1429 1.80956C9.51777 2.43468 9.16658 3.28253 9.16658 4.16658C9.16658 5.05064 9.51777 5.89849 10.1429 6.52361C10.768 7.14873 11.6159 7.49992 12.4999 7.49992C13.384 7.49992 14.2318 7.14873 14.8569 6.52361C15.4821 5.89849 15.8333 5.05064 15.8333 4.16658C15.8333 3.28253 15.4821 2.43468 14.8569 1.80956C14.2318 1.18444 13.384 0.833252 12.4999 0.833252ZM12.4999 2.41659C13.4666 2.41659 14.2499 3.19992 14.2499 4.16658C14.2499 5.13325 13.4666 5.91658 12.4999 5.91658C12.0358 5.91658 11.5907 5.73221 11.2625 5.40402C10.9343 5.07583 10.7499 4.63071 10.7499 4.16658C10.7499 3.70246 10.9343 3.25734 11.2625 2.92915C11.5907 2.60096 12.0358 2.41659 12.4999 2.41659ZM3.33325 3.33325V5.83325H0.833252V7.49992H3.33325V9.99992H4.99992V7.49992H7.49992V5.83325H4.99992V3.33325H3.33325ZM12.4999 8.33325C10.2749 8.33325 5.83325 9.44158 5.83325 11.6666V14.1666H19.1666V11.6666C19.1666 9.44158 14.7249 8.33325 12.4999 8.33325ZM12.4999 9.91658C14.9749 9.91658 17.5833 11.1333 17.5833 11.6666V12.5833H7.41658V11.6666C7.41658 11.1333 9.99992 9.91658 12.4999 9.91658Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTeamManually);
export default __webpack_public_path__ + "static/media/addTeamManually.36a474c1.svg";
export { ForwardRef as ReactComponent };